import React from "react";
import {
    useExportExcelMutation,
    useExportExcelWithDataMutation,
} from "../../../../app/services/excel/excel";
import { useViewer } from "../../../../app/hooks/hooks";
import classes from "./ExportExcelButton.module.css";
import { ReactComponent as IconExcel } from "../Buttons/icons/icon-excel.svg";

function ExportExcelButton() {
    const [exportExcel] = useExportExcelMutation();
    const [exportWithData] = useExportExcelWithDataMutation();
    const viewer = useViewer();

    const exportExcelHandle = async () => {
        if (!viewer) return;
        if (Object.keys(viewer.models[0].properties.data).length) {
            await exportWithData(viewer.models[0].properties.data);
        } else {
            await exportExcel(0);
        }
    };
    return (
        <button
            className={classes.ExportExcelButton}
            onClick={exportExcelHandle}
        >
            <IconExcel className={classes.icon} />
        </button>
    );
}

export default ExportExcelButton;
